import { render } from "./Result.vue?vue&type=template&id=cff6abd6&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=cff6abd6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cff6abd6"

export default script